var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4496 3.87476C13.8021 3.52237 14.0001 3.0444 14.0002 2.54599C14.0003 2.04758 13.8023 1.56956 13.4499 1.21709C13.0976 0.864619 12.6196 0.666566 12.1212 0.666504C11.6228 0.666441 11.1448 0.864374 10.7923 1.21676L1.89495 10.1161C1.74016 10.2704 1.62569 10.4604 1.56162 10.6694L0.680948 13.5708C0.663719 13.6284 0.662417 13.6897 0.677183 13.748C0.691948 13.8063 0.722229 13.8596 0.764813 13.9021C0.807397 13.9446 0.860695 13.9748 0.919054 13.9895C0.977413 14.0041 1.03865 14.0027 1.09628 13.9854L3.99828 13.1054C4.20706 13.0419 4.39706 12.9282 4.55162 12.7741L13.4496 3.87476Z",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNoteIcon);
export default __webpack_public_path__ + "static/media/editNoteIcon.fa039999cda8c1c1f92c697f9f6de354.svg";
export { ForwardRef as ReactComponent };